export const prefix = 'administration.blocks.type.evaluation.modals.actionsOnEdit';
